import React from 'react';

interface BpmIconProps {
  fill: string;
  height: string;
  width: string;
}

export function BpmIcon({ fill, height, width }: BpmIconProps) {
  return (
    <svg width={height} height={width} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.5 0.5H4C2.0575 0.5 0.5 2.075 0.5 4V21.5H4V4H21.5V0.5ZM28.5 7.5H11C9.0575 7.5 7.5 9.075 7.5 11V28.5H11V11H28.5V7.5ZM32 14.5H18C16.0575 14.5 14.5 16.075 14.5 18V32C14.5 33.925 16.0575 35.5 18 35.5H32C33.925 35.5 35.5 33.925 35.5 32V18C35.5 16.075 33.925 14.5 32 14.5Z"
        fill={fill}
      />
    </svg>
  );
}
